import { Box, Typography, makeStyles } from "@material-ui/core";
import React from "react";

import OperatorStatus from "../OperatorStatus/OperatorStatus";
import PhoneIcon from "../../assets/img/phone.svg";
import OperatorIcon from "../../assets/img/avatar.png";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  telLink: {
    display: "flex",
    alignItems: "center",
    [down("md")]: {
      "& p": {
        fontSize: "14px",
      },
    },
    [down("sm")]: {
      paddingBottom: "0 !important",
      paddingTop: "2px",
    },
    "& img": {
      marginRight: "4px",
    },
  },
  operatorStyles: {
    // width: "20%",
    [down("sm")]: {
      width: "auto",
    },
    [down("xs")]: {
      "& p": {
        fontSize: "12px",
      },
    },
    "@media (max-width: 350px)": {
      maxWidth: "120px",
    },
  },
}));

const Operator = ({ info, classes }) => {
  const { telLink, operatorStyles } = useStyles();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      className={`${operatorStyles} ${classes}`}
    >
      <Box display="flex" flexDirection="column" alignItems="flex-end" mr={2}>
        {info?.name && (
          <Box>
            <Typography variant="body2" color="secondary">
              {info?.name}
            </Typography>
          </Box>
        )}
        {info?.phone && (
          <Box>
            <a href={`tel:${info?.phone}`} className={telLink}>
              <img src={PhoneIcon} alt="phone" />
              <Typography variant="body1" color="secondary">
                {info?.phone}
              </Typography>
            </a>
          </Box>
        )}
      </Box>
      <OperatorStatus
        logoSrc={info?.img || OperatorIcon}
        status={info?.online}
      />
    </Box>
  );
};

export default Operator;
